import { render, staticRenderFns } from "./LoginH5.vue?vue&type=template&id=8cef765e&scoped=true&"
import script from "./LoginH5.vue?vue&type=script&lang=js&"
export * from "./LoginH5.vue?vue&type=script&lang=js&"
import style0 from "./LoginH5.vue?vue&type=style&index=0&id=8cef765e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cef765e",
  null
  
)

export default component.exports